import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyImplantRefundBillItem from './pharmacy-implant-refund-bill-item';
import PharmacyImplantRefundBillItemDetail from './pharmacy-implant-refund-bill-item-detail';
import PharmacyImplantRefundBillItemUpdate from './pharmacy-implant-refund-bill-item-update';
import PharmacyImplantRefundBillItemDeleteDialog from './pharmacy-implant-refund-bill-item-delete-dialog';

const PharmacyImplantRefundBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyImplantRefundBillItem />} />
    <Route path="new" element={<PharmacyImplantRefundBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyImplantRefundBillItemDetail />} />
      <Route path="edit" element={<PharmacyImplantRefundBillItemUpdate />} />
      <Route path="delete" element={<PharmacyImplantRefundBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyImplantRefundBillItemRoutes;
